import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/platnosc-sukces")({
  head: () =>
    buildSeoMeta({
      title: "Płatność zakończona sukcesem | SyncTech",
      description: "Dziękujemy za zakup. Wkrótce skontaktujemy się mailowo.",
      path: "/platnosc-sukces",
      noindex: true,
    }),
  component: SuccessPage,
});

function SuccessPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="flex min-h-[70vh] items-center justify-center px-6 pt-32 pb-24">
        <div className="max-w-xl text-center">
          <CheckCircle2 className="mx-auto h-20 w-20 text-primary" />
          <h1 className="mt-6 font-display text-4xl font-bold md:text-5xl">
            Dziękujemy za płatność!
          </h1>
          <p className="mt-4 text-muted-foreground">
            Potwierdzenie wysłaliśmy na Twój e-mail. W ciągu 24h skontaktujemy się,
            żeby umówić start wdrożenia.
          </p>
          <div className="mt-8 flex justify-center gap-3">
            <Button asChild>
              <Link to="/">Wróć na stronę główną</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
